import request from '../utils/request'
import { wxConfig } from '../config'

// 登录
/**
 * @description 登录接口
 * @param {string} username 用户名
 * @param {string} password 密码
 * xjm
 */
export const login = (playLoad) => {
  return request({
    url: '/gateway/user/v1/manage/login/factorySet',
    method: 'post',
    data: {
      ...playLoad,
    },
  })
}

/**
 * @description 获取微信sdk凭证
 */
export const getWxSDK = () => {
  return request({
    url: '/gateway/user/v1/wechat/sdk',
    method: 'get',
    params: {
      appId: wxConfig.appId,
      // https://imei-pre.charge-spot.com/ with last '/'
      url: `${window.location.origin}${window.location.pathname}`,
    },
  })
}

/**
 * @description 将imei和uuid绑定
 * @param {string} deviceImei imei号
 * @param {string} deviceSn uuid号
 * @param {string} devicePatternId 设备类型
 * @param {string} putInArea 投放地区
 * @param {string} apkSignAlias apk签名
 */
//  在资产管理版本，将 https://api.demo.chargespot.cn 改为 http://admin.demo.chargespot.cn，imei和uuid绑定的接口除外（依旧调用 api 服务）
//  因此imei和uuid绑定的接口使用的是 sdkUrl

//todo 20220815 两个拦截器代码并没有区别，使用统一拦截器
export const bindImeiUuidCode = (playLoad) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/device/imei/bind',
    method: 'post',
    data: {
      deviceImei: playLoad.deviceImei,
      deviceSn: playLoad.uuid,
      apkSignAlias: playLoad.apkSignAlias,
      devicePatternId: playLoad.devicePatternId,
      putInArea: playLoad.putInArea,
      devicePower: playLoad.adapterPower,
      serialPortMode: playLoad.serialPortMode,
      serialPortMcuCount: playLoad.serialPortMcuCount,
    },
  })
}

/**
 * @description 通过机柜编号ID获取机柜UUID（deviceSn）
 * @param {string} deviceNo
 */
export const getUuidInfo = (deviceNo) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/getDeviceSnByNo',
    method: 'get',
    params: {
      deviceNo,
    },
  })
}

/**
 * @description 扫码获取弹出电池信息
 * @param {string} deviceId
 */
export const getPopUuidInfo = (deviceId, userId) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/deviceInfo',
    method: 'get',
    params: {
      deviceId,
    },
  })
}

/**
 * @description 弹出机柜电池
 * @param {string} deviceId 机柜id
 * @param {number} releaseNum 弹出电池数量
 */
export const popSystemBattery = (deviceSn, releaseNum, userId) => {
  return request({
    url: '/deviceGateway/base/v2/factorySet/releasePowerByNum',
    method: 'post',
    data: {
      deviceSn,
      releaseNum,
      userId,
    },
  })
}

/**
 * @description 远程重启机柜
 * @param {string} deviceId 设备id
 */
export const resetSystem = (deviceId) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/popReleaseBattery',
    method: 'post',
    data: {
      deviceId,
    },
  })
}

/**
 * @description 获取机芯配置数据
 * @param {string} deviceId 设备id
 */
export const movementSystemInfo = (deviceId) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/mcu/address/info',
    method: 'get',
    params: {
      deviceId,
    },
  })
}

/**
 * @description 提交机芯配置
 * @param {string} data 配置参数
 */
export const submitMovementSystemInfo = (data) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/mcu/address',
    method: 'post',
    data: data,
  })
}

/**
 * 获取机柜弹出详情(1.0协议)
 * @param {string} deviceId 设备id
 */
export const getSystemDetail = (deviceId) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/popPowerDetail',
    method: 'get',
    params: {
      deviceId,
    },
  })
}

/**
 * 获取机柜弹出详情(2.0协议)
 * @param {string} deviceId 设备id
 */
export const getSystemTwoDetail = (deviceId) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/device/base/detail',
    method: 'get',
    params: {
      deviceId,
    },
  })
}

/**
 * 获取机柜孔位(2.0协议)
 * @param {string} data 参数
 */
export const getHoleDetailInfo = (data) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/device/base/ship/detail',
    method: 'get',
    params: data,
  })
}

/**
 * 弹出单个电池
 * @param {number} deviceId 电池id
 * @param {number} cabinetIndex 电池所在孔位序号
 */
export const popSystemIndex = (deviceSn, cabinetIndex, userId) => {
  return request({
    url: '/deviceGateway/base/v2/factorySet/releasePowerByIndex',
    method: 'post',
    data: {
      deviceSn,
      index: cabinetIndex,
      userId,
    },
  })
}

/**
 * 获取备用电池列表
 * @param {number} businessmenId 商家
 * @param {number} page 页码
 * @param {number} powerState 页码 1:备用  2:已投入使用  3:回收
 */
export const getBackupList = (businessmenId, page, powerState) => {
  return request({
    url: '/gateway/trader/v1/businessmen/battery/backup',
    method: 'get',
    params: {
      businessmenId,
      page,
      powerState,
    },
  })
}

/**
 * 新增/回收备用电池时 检验
 * @param {number} type 类型 1-新增 2-回收
 * @param {number} businessmenId 商家id batteryData
 * @param {string} batteryData 电池编号（多个编号时用逗号隔开）
 */
export const backupCheck = (type, businessmenId, batteryData) => {
  return request({
    url: '/gateway/trader/v1/businessmen/battery/backup/check',
    method: 'post',
    data: {
      type,
      businessmenId,
      batteryData,
    },
  })
}

/**
 * 新增/回收备用电池
 * @param {number} type 类型 1-新增 2-回收
 * @param {number} businessmenId 商家id batteryData
 * @param {string} batteryData 电池编号（多个编号时用逗号隔开）
 */
export const backupAdd = (type, businessmenId, batteryData) => {
  return request({
    url: '/gateway/trader/v1/businessmen/battery/backup/save',
    method: 'post',
    data: {
      type,
      businessmenId,
      batteryData,
    },
  })
}

/**
 * @description 扫码获取设备信息
 * @param {string} deviceUuid
 */
export const getDeviceInfoByUuid = (deviceUuid) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/scan/getDeviceInfoByUuid',
    method: 'get',
    params: {
      deviceUuid,
    },
  })
}

/**
 * @description 扫码获取当前设备是几代设备
 * @param {string} deviceUuid
 */
export const getDeviceVersionInfoByUuid = (deviceUuid) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/getDeviceInfo/simple',
    method: 'get',
    params: {
      deviceUuid,
    },
  })
}

/**
 * @description 弹出POS机
 * @param {string} id 设备POS id
 */
export const popupPOSById = (id) => {
  return request({
    url: '/deviceGateway/base/v1/factorySet/pos/unlock',
    method: 'post',
    data: {
      id,
    },
  })
}
